// Excerpts from signed client reference letters. Each signer approved public
// use of this excerpt and attribution (owner confirmation, 2026-11-02).
// Square brackets mark a name expanded from the letter's abbreviation.
// Signers are shown by initials only (owner decision, 2026-11-02).
// Do not edit a quote without the signer's approval.

export type Testimonial = {
  id: string;
  quote: string;
  name: string;
  role?: string;
  organization: string;
  context: string;
  studyId?: string;
};

export const testimonials: Testimonial[] = [
  {
    id: 'garden-marquee',
    quote:
      'Throughout the engagement, [Scaled Tech] demonstrated strong technical capability, creativity, and attention to detail.',
    name: 'T. T.',
    organization: 'The Garden Marquee',
    context: 'Delivered by Scaled Tech',
    studyId: 'venue-workflow',
  },
  {
    id: 'tile-contractors',
    quote:
      'The platform was ahead of its time when launched. It was designed as a shared CMS capable of supporting multiple websites from a single codebase while allowing each site to maintain its own domain, branding, navigation, URL structure, and site-specific configuration.',
    name: 'N. P.',
    role: 'Founder / Project Owner',
    organization: 'TileContractors Inc.',
    context: 'Delivered through our predecessor software practice',
    studyId: 'multi-site-publishing',
  },
  {
    id: 'broadstreet-mobile',
    quote:
      '[Expert Web Coder] demonstrated the ability to work across business, product, design, quality assurance, and technology teams while supporting enterprise clients with branding, compliance, governance, security, and end-user experience requirements.',
    name: 'P. A.',
    role: 'Former Senior Executive',
    organization: 'Broadstreet Mobile',
    context: 'Enterprise mobile consulting through our predecessor software practice',
  },
  {
    id: 'paradisal-imagery',
    quote:
      'He built tools people could actually use, kept complex platforms running reliably, and remained someone we could depend on for technical delivery.',
    name: 'M. W.',
    role: 'Owner / Creative Director',
    organization: 'Paradisal Imagery Inc.',
    context: 'CMS and digital asset platform through our predecessor software practice',
  },
];

export const testimonialForStudy = (studyId: string) =>
  testimonials.find((item) => item.studyId === studyId);
